/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS202: Simplify dynamic range loops
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

// Mirrors Results::ResultsFilter::ALL. Pinned by an example in
// spec/helpers/results_helper_spec.rb -- it lives in flashvote-core, which
// nothing in this repo compiles against.
const ALL_FILTER_KEY = 'all';

// Mirrors Results::ResultsFilter::CROSSTAB, matched as a prefix the way the
// server does -- so CROSSTAB_BINARY ('crosstab_binary') counts as a crosstab
// key too. Same caveat as ALL_FILTER_KEY: the constant lives in flashvote-core.
const CROSSTAB_FILTER_PREFIX = 'crosstab';

const COMPRESS_ICON_PATH = "path://M152,32c4.4,0,8,3.6,8,8l0,144c0,4.4-3.6,8-8,8L8,192c-4.4,0-8-3.6-8-8s3.6-8,8-8l136,0,0-136c0-4.4,3.6-8,8-8zm144,0c4.4,0,8,3.6,8,8l0,136,136,0c4.4,0,8,3.6,8,8s-3.6,8-8,8l-144,0c-4.4,0-8-3.6-8-8l0-144c0-4.4,3.6-8,8-8zM0,328c0-4.4,3.6-8,8-8l144,0c4.4,0,8,3.6,8,8l0,144c0,4.4-3.6,8-8,8s-8-3.6-8-8l0-136L8,336c-4.4,0-8-3.6-8-8zm288,0c0-4.4,3.6-8,8-8l144,0c4.4,0,8,3.6,8,8s-3.6,8-8,8l-136,0,0,136c0,4.4-3.6,8-8,8s-8-3.6-8-8l0-144z";
const EXPAND_ICON_PATH = "path://M152,32c4.4,0,8,3.6,8,8s-3.6,8-8,8L16,48l0,136c0,4.4-3.6,8-8,8s-8-3.6-8-8L0,40c0-4.4,3.6-8,8-8l144,0zM0,328c0-4.4,3.6-8,8-8s8,3.6,8,8l0,136,136,0c4.4,0,8,3.6,8,8s-3.6,8-8,8L8,480c-4.4,0-8-3.6-8-8L0,328zM296,32l144,0c4.4,0,8,3.6,8,8l0,144c0,4.4-3.6,8-8,8s-8-3.6-8-8l0-136L296,48c-4.4,0-8-3.6-8-8s3.6-8,8-8zM448,328l0,144c0,4.4-3.6,8-8,8l-144,0c-4.4,0-8-3.6-8-8s3.6-8,8-8l136,0,0-136c0-4.4,3.6-8,8-8s8,3.6,8,8z";

const SORT_ICON_PATH = "path://path://M133.7,477.7c-3.1,3.1-8.2,3.1-11.3,0l-104-104c-3.1-3.1-3.1-8.2,0-11.3s8.2-3.1,11.3,0L120,452.7,120,40c0-4.4,3.6-8,8-8s8,3.6,8,8l0,412.7,90.3-90.3c3.1-3.1,8.2-3.1,11.3,0s3.1,8.2,0,11.3l-104,104zM296,464c-4.4,0-8-3.6-8-8s3.6-8,8-8l80,0c4.4,0,8,3.6,8,8s-3.6,8-8,8l-80,0zm0-144c-4.4,0-8-3.6-8-8s3.6-8,8-8l144,0c4.4,0,8,3.6,8,8s-3.6,8-8,8l-144,0zm0-128c-4.4,0-8-3.6-8-8s3.6-8,8-8l208,0c4.4,0,8,3.6,8,8s-3.6,8-8,8l-208,0zm0-128c-4.4,0-8-3.6-8-8s3.6-8,8-8l272,0c4.4,0,8,3.6,8,8s-3.6,8-8,8L296,64z";
const UNSORT_ICON_PATH = "path://M154.3,509.7c3.1,3.1,8.2,3.1,11.3,0l96-96c3.1-3.1,3.1-8.2,0-11.3s-8.2-3.1-11.3,0L168,484.7,168,264l400,0c4.4,0,8-3.6,8-8s-3.6-8-8-8l-144,0,0-220.7,82.3,82.3c3.1,3.1,8.2,3.1,11.3,0s3.1-8.2,0-11.3l-96-96c-3.1-3.1-8.2-3.1-11.3,0l-96,96c-3.1,3.1-3.1,8.2,0,11.3s8.2,3.1,11.3,0L408,27.3,408,248,8,248c-4.4,0-8,3.6-8,8s3.6,8,8,8l144,0,0,220.7L69.7,402.3c-3.1-3.1-8.2-3.1-11.3,0s-3.1,8.2,0,11.3l96,96zM152,192l16,0,0-152c0-4.4-3.6-8-8-8s-8,3.6-8,8l0,152zM424,320l-16,0,0,152c0,4.4,3.6,8,8,8s8-3.6,8-8l0-152z";

//------------------------------------------------------------------------------
//
//       ECHARTS HELPERS
//
//------------------------------------------------------------------------------

root.formatBarTooltip = function(params) {
  const categoryCount = (params['data'].length - 1)/3; // catLabel, value, value, label, label, tooltip, tooltip
  const offset = 1 + (categoryCount * 2);
  const option = params['data'][0].replace( /\n/g, '<br>' );
  return option + ' <hr/> ' + params['marker'] + params['seriesName'] + ':&nbsp;&nbsp;&nbsp;<strong>'+ params['data'][params['componentIndex'] + offset] + '</strong>';
};

root.formatBarLabel = function(params) {
  const categoryCount = (params['data'].length - 1)/3; // catLabel, value, value, label, label, tooltip, tooltip
  const offset = 1 + categoryCount;
  return params['data'][params['componentIndex'] + offset];
};

root.formatScatterTooltip = params => params.value[2] +
  ' (' + params.seriesName + ')' +
  '<br/>Importance: ' +
  params.value[0] +
  ', Satisfaction: ' +
  params.value[1];

root.formatToolboxTooltip = param => '<div>&nbsp;' + param.title + '&nbsp;</div>';

root.smallTooltipPosition = (point, params, dom, rect, size) => ['20%', point[1]+10 ];

//------------------------------------------------------------------------------
//
//       ECHARTS EVENT HANDLERS
//
//------------------------------------------------------------------------------

const toggleDataTable = function(el) {
  const parent = $("#"+el);
  parent.find('.hide-data-table').removeClass('hidden');
  parent.find('.hide-data-table').show();
  parent.find('.data-table').show();
  //parent.find('.show-data-table').toggle()
  return parent.find('.chart-container').hide();
};

const toggleSort = function(el) {
  let option;
  const parent = $("#"+el);
  const sorted = parent.data('sorted');

  //if sorted, unsort
  if (sorted) {
    let optionLabels;
    parent.data('sorted', null);
    parent.data('sort-index', null);

    //reset to original order
    option = getChartOptionForWidth(parent, width);
    if (option.yAxis.type === 'category') {
      optionLabels = option.yAxis.data;
      optionLabels.sort((a, b) => a.sortIndex - b.sortIndex).reverse();
    } else {
      optionLabels = option.xAxis.data;
      optionLabels.sort((a, b) => a.sortIndex - b.sortIndex);
    }

    option.toolbox.feature.mySort.icon = SORT_ICON_PATH;
    option.toolbox.feature.mySort.title = 'Sort';

    const chart = parent.data('chart');
    chart.clear();
    return chart.setOption(option, {
      replaceMerge: ['yAxis']
    });

  //if unsorted, sort
  } else {
    parent.data('sorted', true);
    option = getChartOptionForWidth(parent, width);
    option.toolbox.feature.mySort.icon = UNSORT_ICON_PATH;
    option.toolbox.feature.mySort.title = 'Original Order';

    return sortChart(parent, 0);
  }
};

const toggleExpandChart = function(el) {
  let options;
  const parent = $("#"+el);
  const container = parent.find('.chart-container');
  let chart = parent.data('chart');

  if (container.hasClass('expanded')) {
    container.removeClass('expanded');
    parent.data('collapsed', true);
    options = parent.data('large-options');
    if (options) {
      options['toolbox']['feature']['myExpand']['title'] = 'Full Screen';
      options['toolbox']['feature']['myExpand']['icon'] = EXPAND_ICON_PATH;
    }

    return resizeChart(parent, true);
  } else {
    container.addClass('expanded');
    const windowHeight = window.innerHeight;
    const windowWidth = window.innerWidth;
    chart = parent.data('chart');
    options = parent.data('large-options');
    if (!options) {
      options = chart.getOption();
    }
    options['toolbox']['feature']['myExpand']['title'] = 'Exit Full Screen';
    options['toolbox']['feature']['myExpand']['icon'] = COMPRESS_ICON_PATH;
    chart.clear();
    chart.setOption(options, {
      replaceMerge: ['xAxis', 'yAxis', 'legend', 'grid', 'graphic', 'title', 'tooltip','toolbox']
    });
    const sizing = { width: windowWidth, height: windowHeight };
    return chart.resize(sizing);
  }
};

const chartClicked = function(chart, dom_id, event) {
  const obj = $('#' + dom_id);
  const parent = obj.parents('.question');
  const sorted = parent.data('sorted');
  const prevSortIndex = parent.data('sort-index');
  const newIndex = event.seriesIndex;
  if (sorted && (newIndex !== prevSortIndex)) {

    return sortChart(parent, newIndex);
  }
};


//------------------------------------------------------------------------------
//
//       ECHARTS FEATURES
//
//------------------------------------------------------------------------------

var sortChart = function(parent, seriesIndex) {
  let optionLabels;
  if (seriesIndex === undefined) {
    seriesIndex = 0;
  }
  parent.data('sort-index', seriesIndex);

  const chart = parent.data('chart');

  const windowWidth = window.innerWidth;
  const option = getChartOptionForWidth(parent, windowWidth);

  const data = option.dataset['source'];

  // option label + (value, label, tooltip) for each series
  const seriesCount = (data[0].length - 1)/3;

  const sortArr = [];
  for (let i = 0, end = data.length, asc = 0 <= end; asc ? i <= end : i >= end; asc ? i++ : i--) {
    var r = data[i];
    if (Array.isArray(r)) {
      sortArr.push([i, r[1 + seriesIndex], r[0]]);
    }
  }

  sortArr.sort((a, b) => a[1] - b[1]);
  if (option.yAxis.type === 'category') {
    optionLabels = option.yAxis.data;
    optionLabels.sort((a, b) => a.sortIndex - b.sortIndex).reverse();
  } else {
    optionLabels = option.xAxis.data;
    optionLabels.sort((a, b) => a.sortIndex - b.sortIndex).reverse();
  }

  const sortedLabels = [];
  for (var pair of Array.from(sortArr)) {
    sortedLabels.push(optionLabels[pair[0]]);
  }
  if (option.yAxis.type === 'category') {
    option.yAxis.data = sortedLabels;
  } else {
    option.xAxis.data = sortedLabels;
  }
  chart.clear();
  return chart.setOption(option, {
    replaceMerge: ['xAxis', 'yAxis', 'legend', 'grid', 'graphic', 'title', 'tooltip', 'toolbox']
  });
};

root.resizeCharts = () => $('.question').each(function() {
  return resizeChart(this);
});

var resizeChart = function(parent, forceResize) {
  if (forceResize == null) { forceResize = false; }
  const windowHeight = window.innerHeight;
  const windowWidth = window.innerWidth;

  const container = $(parent);
  const containerId = container.prop('id');
  const chartDiv = container.find('.responsive-chart');
  
  const width = container.width();
  const chart = container.data('chart');

  //if exiting Full Screen mode, force resize
  if (chart) {
    let chartHeight;
    const prevHeight = container.data('winHeight');

    //if window was resized horizontally but not vertically, don't recalculate chart height
    if ((prevHeight === windowHeight) && !forceResize) {
      chartHeight = chart.getHeight();
    } else {
      const margin = 40;
      const idealHeight = container.data('ideal-height');
      chartHeight = Math.min(idealHeight, windowHeight);
    }

    const sizing = { width, height: chartHeight };

    const options = getChartOptionForWidth(container, windowWidth);
    if (options) {
      chart.clear();
      chart.setOption(options, {
        replaceMerge: ['xAxis', 'yAxis', 'legend', 'grid', 'graphic', 'title', 'tooltip', 'toolbox']
      });
    }
    chart.resize(sizing);
    if (chartDiv) {
      chart.off('finished');
      chart.on('finished', function() {
        root.patchChartAria(chartDiv.prop('id'));
      });
    }
    return container.data('winHeight', windowHeight);
  }
};



//------------------------------------------------------------------------------
//
//       OTHER EVENT HANDLERS
//
//------------------------------------------------------------------------------

const showDataTableClicked = function(el) {
  const obj = $(el);
  const parent = obj.parents('.data-table-view');
  parent.find('.hide-data-table,.data-table').show();
  return parent.find('.show-data-table').hide();
};

const hideDataTableClicked = function(el) {
  const obj = $(el);
  const parent = obj.parents('.data-table-view');
  parent.find('.hide-data-table,.data-table').hide();
  return parent.find('.show-data-table').show();
};

const showChartClicked = function(el) {
  const obj = $(el);
  const parent = obj.parents('.question');
  parent.find('.hide-data-table').addClass('hidden');
  parent.find('.hide-data-table').hide();
  parent.find('.data-table').hide();
  return parent.find('.chart-container').show();
};


//------------------------------------------------------------------------------
//
//       MISC HELPERS
//
//------------------------------------------------------------------------------

const filterChanged = function(el) {
  const $el = $(el);
  const filterKey = $el.val();
  const filterLabel = $el.find('option:selected').text();

  if(filterKey.startsWith('scheme')) {
    loadSchemeMap(filterKey);
  } else {
    $('#scheme-map').slideUp();
  }

  $('.question').each(function() {
    return $(this).data('filter-key', filterKey);
  });
  // MVP-4422: #survey-response-count reports the All-responses figures, which do
  // not move with the filter -- the server renders them once and nothing here
  // touches them. These two do move, and are rebuilt from a running max over the
  // per-question AJAX responses, so they start again from nothing.
  //
  // Both start from nothing rather than from the server's seed *deliberately*, and
  // the seed cannot be kept: the numbers the server rendered belong to the key the
  // page was loaded on, not to the key just selected. Land on 'all' and pick a
  // narrow key and the seed is the whole respondent set and the whole panel behind
  // it -- a running max can only raise a seed, so both figures would stay pinned at
  // the previous key's, which for a narrowing filter is always too large. Nothing
  // in the AJAX responses carries the new key's survey-level figures, so there is
  // no correct seed available here.
  //
  // The consequence is that one key reaches the same two numbers by two routes: a
  // direct load of ?filter=local renders them from Results::SurveyStats
  // (_filter_stats.html.haml) and the running max can only raise them, while
  // arriving at 'local' through the selector rebuilds them from 0. The two agree by
  // construction -- SurveyStats' response_count is the max of
  // filtered_response_count and its sampling_basis the max of
  // panel_filtered_response_count, both over survey.results_items, which is the
  // same set these AJAX responses cover -- so the max converges on the server's
  // figure once every question has reported. Where they diverge is a key with no
  // current summaries: there SurveyStats falls back to survey-wide totals the
  // per-question path cannot reach, and this route shows the smaller rebuilt
  // number until the page is reloaded.
  //
  // The count and the margin also keep *independent* maxima, so the pair on screen
  // can come from two different questions -- Q1's count beside Q7's basis. Not
  // fixed here: they are different populations (see panel_participants_count), so
  // there is no single per-question figure to max them over together.
  $('#filtered-response-count').text('0');
  $('#filter-margin-of-error').empty().attr('data-panel-count', 0);
  updateFilterStats(filterKey);
  updateFilterRecapCrosstabClass(filterKey);
  reloadSurveyResults();
  $('#applied-filter-label').text(filterLabel);
  if (typeof (history.pushState) !== "undefined") {
    const currentUrl = window.location.href;
    const {
      title
    } = document;
    const url = new URL(currentUrl);
    url.searchParams.set("filter", filterKey);
    const newUrl = url.href;
    const page = { Title: title, Url: newUrl };
    history.pushState(page, page.Title, page.Url);
  }
  updateFilterDescription(filterKey);
  return updateDownloadLinks(filterKey);
};

// MVP-4422: the count and the margin of error beside the applied filter's name.
// The server renders both rows for every key and hides them on 'all' -- their
// labels are translated server-side and nothing here could rebuild them -- so
// this only has to toggle the inline display:none back off.
var updateFilterStats = function(filterKey) {
  // Scoped to the recap: .filter-stat marks the rows this toggle owns, and a
  // later feature could reasonably reuse the name elsewhere on the page.
  return $('#filter-recap .filter-stat').toggle(filterKey !== ALL_FILTER_KEY);
};

// A crosstab key's label is a full sentence rather than a word or two, so
// #filter-recap carries a .crosstab modifier that shrinks the recap values to
// fit. The server sets it for the key the page loaded on (_survey_stats.html.haml);
// this keeps it in step as the selector changes keys.
var updateFilterRecapCrosstabClass = function(filterKey) {
  return $('#filter-recap').toggleClass(
    'crosstab', filterKey.startsWith(CROSSTAB_FILTER_PREFIX)
  );
};

var updateFilterDescription = function(filterKey) {
  const filterDescription = $('#filter-description');
  const tooltipId = filterDescription.data('toggle');
  const tooltip = $('#' + tooltipId);
  const description = filterDescription.data('descriptions-' + filterKey);
  return tooltip.html(description);
};

const updateFilterCount = function(new_count) {
  if (new_count == null || isNaN(new_count)) { return; }
  const $el = $('#filtered-response-count');
  const s = $el.text();
  let count = 0;
  const parsed = parseInt(s, 10);
  if (s !== '' && !isNaN(parsed)) {
    count = parsed;
  }
  return $el.text(Math.max(new_count, count));
};

// MVP-4422: the margin beside the filtered count is quoted over the filtered
// respondents who are also panel members, which is a different number from the
// count displayed -- so it is carried separately and keeps its own running max,
// on the element rather than in the text. Mirrors
// ResultsHelper#margin_of_error_text and Results::SurveyStats.sampling_error; a
// survey with no member panel has a zero basis and quotes no margin at all.
//
// #survey-margin-of-error is not touched: it belongs to the All-responses figures
// now, which the server renders and no filter change moves.
const updateFilterSamplingError = function(new_panel_count) {
  const $el = $('#filter-margin-of-error');
  if (!$el.length || new_panel_count == null || isNaN(new_panel_count)) { return; }

  // attr(), not data(): jQuery's data store is read once from the attribute and
  // then cached, so a data() write would leave the DOM showing the server's seed
  // for good. Keeping the running max on the attribute means the element itself
  // is the state, which is also what lets a spec read it back.
  const previous = parseInt($el.attr('data-panel-count'), 10);
  const count = Math.max(new_panel_count, isNaN(previous) ? 0 : previous);
  $el.attr('data-panel-count', count);

  if (count <= 0) { return $el.empty(); }

  const samplingError = Math.pow(0.96 / count, 0.5);
  let text;
  if (samplingError <= 0.0049) {
    text = $el.data('margin-label').replace('%{percent}', '< 1%');
  } else if (samplingError <= 0.15) {
    const pct = Math.round(samplingError * 100) + '%';
    text = $el.data('margin-label').replace('%{percent}', pct);
  } else {
    text = $el.data('large-margin-label');
  }
  return $el.text(text);
};

var getChartOptionForWidth = function(parent, width) {
  let options;
  if (width < 640) {
    return options = parent.data('small-options');
  } else if (width < 900) {
    return options = parent.data('medium-options');
  } else {
    return options = parent.data('large-options');
  }
};



//------------------------------------------------------------------------------
//
//       ECHART SETUP
//
//------------------------------------------------------------------------------

root.addFunctionOptions = function(all_options, dom_id, two_axis_type, formatter_function) {
  const small = all_options['small'];
  const medium = all_options['medium'];
  const large = all_options['large'];
  for (var option of [small, medium, large]) {
    // Specify the configuration items and data for the chart
    option['tooltip']['formatter'] = formatter_function;
    if (two_axis_type) {
      var l = option['series'].length;
      for (var i = 0, end = l, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
        option['series'][i]['label']['formatter'] = formatBarLabel;
      }
    }
    if ((option['toolbox'] !== undefined) && (option['toolbox'] !== null)) {
      option['toolbox']['tooltip']['formatter'] = formatToolboxTooltip;
      option['toolbox']['feature']['myTableView']['onclick'] = () => toggleDataTable(dom_id);
      option['toolbox']['feature']['myExpand']['onclick'] = () => toggleExpandChart(dom_id);
      option['toolbox']['feature']['mySort']['onclick'] = () => toggleSort(dom_id);
    }
  }
  return {'small': small, 'medium': medium, 'large': large};
};

root.patchChartAria = function(domId) {
  var container = document.getElementById(domId);
  if (!container) return;

  // ── 1. Promote aria-label to the first child div (your existing logic) ──
  var innerDiv = container.querySelector(':scope > div:nth-child(1)');
  if (innerDiv) {
    innerDiv.setAttribute('role', 'img');
    innerDiv.removeAttribute('tabindex');          // img role must NOT be focusable
    var ariaLabel = container.getAttribute('aria-label');
    if (ariaLabel) {
      innerDiv.setAttribute('aria-label', ariaLabel);
      container.removeAttribute('aria-label');
    }
  }

  // ── 2. Remove tabindex from ALL descendant divs eCharts injects ──
  // Covers nested zrender layers, not just direct children
  container.querySelectorAll('div[tabindex]').forEach(el => {
    el.removeAttribute('tabindex');
    // If the div has no role and was only focusable via tabindex,
    // it no longer needs one — but defensively hide it from AT entirely
    if (!el.getAttribute('role') && !el.getAttribute('aria-label')) {
      el.setAttribute('aria-hidden', 'true');
    }
  });

  // ── 3. Handle canvas elements ──
  // A <canvas tabindex="0"> with no role triggers BOTH issues.
  // Since the parent div[role="img"] already describes the chart,
  // hide canvases from the accessibility tree entirely.
  container.querySelectorAll('canvas').forEach(canvas => {
    canvas.setAttribute('tabindex', '-1');
    canvas.setAttribute('aria-hidden', 'true');   // stronger than inert for AT
    canvas.removeAttribute('role');               // strip any role eCharts may set
  });

  // ── 4. Hide the zrender image sprite from AT ──
  container.querySelectorAll('img[data-zr-dom-id]').forEach(el => {
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('tabindex', '-1');
  });

  // ── 5. Suppress eCharts tooltip divs ──
  // Tooltips are visually rendered but not keyboard-navigable in a meaningful way.
  // They often have tabindex="0" with no role.
  container.querySelectorAll('div[class*="tooltip"], div[class*="zr-"]').forEach(el => {
    if (!el.getAttribute('role')) {
      el.setAttribute('aria-hidden', 'true');
      el.removeAttribute('tabindex');
    }
  });

  // ── 6. Final sweep: any remaining focusable element with no valid role ──
  // WCAG 4.1.2 requires name, role, value for all UI components.
  // If it's focusable but has no role and no aria-label, it will fail.
  container.querySelectorAll('[tabindex="0"]').forEach(el => {
    const role = el.getAttribute('role');
    const label = el.getAttribute('aria-label') || el.getAttribute('aria-labelledby');
    if (!role || !label) {
      el.removeAttribute('tabindex');
      el.setAttribute('aria-hidden', 'true');
    }
  });
};

root.addChartEventHandlers = function(chart, dom_id) {
  chart.on('click', params => chartClicked(chart, dom_id, params));
  patchChartAria(dom_id);
};


//------------------------------------------------------------------------------
//
//       LOAD RESULTS
//
//------------------------------------------------------------------------------

root.loadSurveyResults = () => $('.question-placeholder').each(function() {
  return loadQuestionResults(this);
});

root.loadQuestionResults = function(placeholder) {
  const $placeholder = $(placeholder);
  const loading_message = $('.messages').data('loading');
  const loading_results_message = $('.messages').data('loadingResults');
  $placeholder.find('.loading-label').text(loading_results_message);
  const path = $placeholder.data('path');
  const filter_key = $placeholder.data('filter-key');
  const filter_account_key = $placeholder.data('filter-account');
  const reload_link = $placeholder.data('reload-link');
  const index = $placeholder.data('index');
  const data = { 'filter_account': filter_account_key, 'filter': filter_key, 'index': index };
  const usp = new URLSearchParams(window.location.search)
  const viewComments = usp.get('view_comments')
  if (viewComments != null) { data['view_comments'] = viewComments; }
  if (path) {
    let jqxhr;
    return jqxhr = $.get(path, data).fail(function(jqXHR, textStatus, errorThrown) {
      $placeholder.find('.loading-label').addClass('error');
      $placeholder.find('.loading-label').empty();
      $placeholder.find('.loading').remove();
      $placeholder.find('.question-reload').removeClass('hidden').html(reload_link);
    });
  }
};

root.reloadSurveyResults = function() {
  const windowHeight = window.innerHeight;
  return $('.question').each(function() {
    const parent = $(this);
    parent.data('sorted',null);
    return loadQuestionResults(this);
  });
};

//TODO - Is this still used??
root.reloadQuestionResults = function(question, sizing, filter) {
  const $question = $(question);
  const loading_message = $('.messages').data('loading');
  const loading_results_message = $('.messages').data('loadingResults');
  //$placeholder.find('.loading-label').text(loading_results_message)
  const path = $placeholder.data('path');
  const filter_key = $placeholder.data('filter-key');
  const filter_account_key = $placeholder.data('filter-account');
  const reload_link = $placeholder.data('reload-link');
  const index = $placeholder.data('index');
  const data = { 'filter_account': filter_account_key, 'filter': filter_key, 'index': index, 'sizing': sizing };
  if (path) {
    let jqxhr;
    return jqxhr = $.get(path, data).fail(function(jqXHR, textStatus, errorThrown) {
      $placeholder.find('.loading-label').addClass('error');
      $placeholder.find('.loading-label').empty();
      $placeholder.find('.loading').remove();
      $placeholder.find('.question-reload').removeClass('hidden').html(reload_link);
    });
  }
};

//TODO - still used??
root.reloadChart = function(question, sizing) {
  const loading_message = $('.messages').data('loading');
  const loading_results_message = $('.messages').data('loadingResults');
  question.find('.loading-label').text(loading_results_message);
  const path = question.data('path');
  const filter_key = question.data('filter-key');
  const filter_account_key = question.data('filter-account');
  const reload_link = question.data('reload-link');
  const index = question.data('index');
  const data = { 'filter_account': filter_account_key, 'filter': filter_key, 'index': index, 'sizing': sizing, 'chart': true };
  if (path) {
    let jqxhr;
    return jqxhr = $.get(path, data).fail(function(jqXHR, textStatus, errorThrown) {
      question.find('.loading-label').addClass('error');
      question.find('.loading-label').empty();
      question.find('.loading').remove();
      question.find('.question-reload').removeClass('hidden').html(reload_link);
    });
  }
};

root.loadSchemeMap = function(filterKey) {
  const container = $('#scheme-map');
  const path = container.data('path');
  const data = { 'filter': filterKey };
  if (path) {
    let jqxhr;
    return jqxhr = $.get(path, data, function() {
      $('#scheme-map').slideDown();
      root.polygonMap = initializePolygonMap();
    }).fail(function(jqXHR, textStatus, errorThrown) {
      container.slideUp();
    });
  }
};

var updateDownloadLinks = function(filterKey) {
  const container = $('#download-links');
  const links = container.find('a');
  return $(links).each(function() {
    const urlObject = new URL(this.href);
    urlObject.searchParams.set('filter', filterKey);
    return this.href = urlObject.toString();
  });
};

//------------------------------------------------------------------------------
//
//       INIT
//
//------------------------------------------------------------------------------

const initFilters = function() {
  const $filter_form = $('#results-filter-form');
  const usp = new URLSearchParams(window.location.search);
  for (var key of ['rtn', 'sales']) {
    var value = usp.get(key);
    if (value !== null) { $('#results-filter-form').append(`<input type='hidden' name='${key}' value='${value}' />`); }
  }
  $("#results-filter").change(function() {
    return filterChanged(this);
  });
};

const initCommunityFilter = function() {
  const $filter_form = $('#results-filter-form');
  const $account_autocomplete = $("#results-autocomplete-account");
  $account_autocomplete.focus(function() {
    $(this).val('');
  });
  $account_autocomplete.focusout(function() {
    $(this).val($(this).data('label'));
  });
  $account_autocomplete.autocomplete({
    minLength: 2,
    delay: 200,
    source(request, response) {
      $.get('/communities/survey_suggest', {
        q: request.term,
        survey: $("#results-autocomplete-survey").val()
      },
        (data => response(data)), "json");
    },
    select(event, ui) {
      const account = ui.item;
      const account_label = account.label;
      $('#results-filter-account').val(account.value);
      $account_autocomplete.val(account_label);
      $account_autocomplete.data('label', account_label);
      $filter_form.submit();
      return false;
    },
    focus(event, ui) {
      const account = ui.item;
      $account_autocomplete.val(account.label);
      return false;
    }
  });
};

const initDataTableLinks = function(el) {
  if (el === undefined) {
    $('.show-data-table a').click(function() {
      showDataTableClicked(this);
      return false;
    });
    $('.hide-data-table a').click(function() {
      hideDataTableClicked(this);
      return false;
    });
    return $('a.show-chart').click(function() {
      showChartClicked(this);
      return false;
    });

  } else {
    el.find('.show-data-table a').click(function() {
      showDataTableClicked(this);
      return false;
    });
    el.find('.hide-data-table a').click(function() {
      hideDataTableClicked(this);
      return false;
    });
    return el.find('.hide-data-table a.show-chart').click(function() {
      showChartClicked(this);
      return false;
    });
  }
};

const initStickyHeader = () => window.onscroll = function() {
  const filter = $('#results-filter-form');
  const filterWrapper = $('#filter-wrapper');
  if (filterWrapper.length) {
    const {
      top
    } = filterWrapper[0].getBoundingClientRect();
    const {
      bottom
    } = filterWrapper[0].getBoundingClientRect();
    const breakpoint = filter.data('stickyBreakpoint');

    if ((top < 5) && !filter.hasClass('sticky-header')) {
      filter.data('stickyBreakpoint', window.scrollY);
      $('#sticky-filter-wrapper')[0].appendChild(filter[0]);
      return $('#sticky-header').fadeIn();

    } else if (breakpoint && (window.scrollY < breakpoint)) {
      filter.data('stickyBreakpoint', null);
      $('#filter-wrapper')[0].appendChild(filter[0]);
      return $('#sticky-header').fadeOut();
    }
  }
};


root.initQuestionResults = function(el, newFilterCount, newPanelCount) {

  const $el = $(el);
  $el.foundation();
  if($el.find('.word-cloud:visible').length) {
    initWordClouds(el);
  }
  initTextResponses(el);
  initDataTableLinks(el);
  initFlagResponseDialog();
  updateFilterCount(newFilterCount);
  return updateFilterSamplingError(newPanelCount);
};

function initResultsOnLoad() {
  if ($('#results-filter-form').length) {
    initFilters();
  }
  if ($('#results-autocomplete-form').length) {
    initCommunityFilter();
  }
  if ($('.data-table').length) {
    initDataTableLinks();
  }
  if ($('.question-placeholder').length) {
    loadSurveyResults();
    window.onresize = () => resizeCharts();
  }
  if ($('#results-filter-form').length) {
    return initStickyHeader();
  }
}

document.addEventListener('turbo:load', initResultsOnLoad);

function __guardMethod__(obj, methodName, transform) {
  if (typeof obj !== 'undefined' && obj !== null && typeof obj[methodName] === 'function') {
    return transform(obj, methodName);
  } else {
    return undefined;
  }
}